import { Fade, Modal } from "@mui/material";
import React, { FC } from "react";
import type { ModalProps } from "@mui/material";
import cn from "classnames";
import styles from "./ImageShowModal.module.scss";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SafeImage from "Components/UI/SafeImage/SafeImage";

type Props = Omit<ModalProps, "open" | "onClose" | "children"> & {
  className?: string;
  src: string | undefined;
};

const ImageShowModal: FC<Props> = ({ className, src, ...props }) => {
  const modal = useModal();

  const handleClose = () => {
    modal.hide();
  };

  // Mirrors nice-modal's muiDialogV5 helper: settle hide() and unmount once faded out.
  const handleExited = () => {
    modal.resolveHide();
    if (!modal.keepMounted) modal.remove();
  };

  return (
    <Modal
      open={modal.visible}
      onClose={handleClose}
      closeAfterTransition
      {...props}
      className={cn(styles.modal, className)}
    >
      {/* One transition child that holds the ref and focus, so MUI can trap and restore it.
          SafeImage cannot take a ref, hence the frame. */}
      <Fade in={modal.visible} onExited={handleExited}>
        <div className={styles.frame}>
          <SafeImage src={src} alt="Full-size image" />
        </div>
      </Fade>
    </Modal>
  );
};

export default NiceModal.create(ImageShowModal);
